import { Persona } from "@/api/personas";
import { useEffect, useRef } from "react";
import { PersonaImageAvatar } from "@/components/PersonaImageAvatar";
import { apiUrl } from "@/api/api";
import { cn } from "@/lib/utils";

export function PersonaAvatar({
  className,
  persona,
}: {
  className?: string;
  persona: Pick<
    Persona,
    "persona_id" | "name" | "gender" | "avatar_id" | "persona_video_avatar"
  >;
}) {
  const videoRef = useRef<HTMLVideoElement | null>(null);

  useEffect(() => {
    const videoElement = videoRef.current;
    if (videoElement) {
      const handleVideoEnd = () => {
        const randomDelay = Math.floor(Math.random() * 5000) + 1000;
        setTimeout(() => {
          videoElement.play();
        }, randomDelay);
      };

      videoElement.addEventListener("ended", handleVideoEnd);

      return () => {
        videoElement.removeEventListener("ended", handleVideoEnd);
      };
    }
  }, []);

  return (
    <div
      className={cn(
        "relative h-16 aspect-square flex justify-center",
        className,
      )}
    >
      <div className="w-auto aspect-square rounded-full">
        {persona.persona_video_avatar ? (
          <video
            className="h-full rounded-full object-cover"
            ref={videoRef}
            loop
            autoPlay
            muted
          >
            <source src={persona.persona_video_avatar} type="video/mp4" />
          </video>
        ) : (
          <PersonaImageAvatar
            src={
              persona.avatar_id !== "" && persona.avatar_id !== undefined
                ? `${apiUrl}/get-file?url=persona-knowledge-base/${persona.persona_id}/${persona.avatar_id}`
                : undefined
            }
            altText={persona.name || "Avatar"}
            className="w-full h-full"
            gender={persona.gender}
          />
        )}
      </div>
    </div>
  );
}
